import { defineAction } from '~/prix'
import equipmentLoanFetchAction from './equipmentLoanFetch.action.json' with { type: 'json' }
import { equipmentLoanObject } from '../equipmentLoanObject'
import { equipmentObject } from '~/packages/rural/equipment/equipmentObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { protocolObject } from '~/packages/general/protocol/protocolObject'

const equipmentLoanFetchDefinition = defineAction({
  ...equipmentLoanFetchAction,

  input: equipmentLoanObject.pick({
    id: true,
  }),
  output: equipmentLoanObject.extend({
    equipment: equipmentObject,
    citizen: citizenObject,
    protocol: protocolObject,
  }),
})

export default equipmentLoanFetchDefinition
